import React, { Component } from 'react';
import { array, bool, func, shape, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm, Field } from 'react-final-form';
import { intlShape, injectIntl } from '../../util/reactIntl';
import { propTypes } from '../../util/types';
import {
  AddImages,
  ImageCrop
} from '../../components';
import css from './EditListingOfferDescriptionForm.module.css';
import { replaceFileName } from './utils';

const ACCEPT_IMAGES = 'image/*';

export class BackgroundPhoto extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCrop: false,
    };
  }

  handleShowCrop = (e, key) => {
    e.preventDefault();
    this.setState({ showCrop: true }, () => this.setState({ showCrop: false }))
  }

  render() {

    const {
      isMobSaf,
      form,
      publicData,
      images,
      intl,
      imageUploadRequested,
      onImageUploadHandler,
      onRemoveImage,
      handleSubmitFile,
      handleCloseCropPopup,
      isOffer,
    } = this.props

    const { showCrop } = this.state;

    const imagesConfig = {
        label: 'Logo',
        tip: 'Recommended photo resolutions: 1920 x 520 px',
        key: 'backgroundPhoto',
        placeholder: '+ Add Background Photo',
        countLimit: 1,
        photoIdKey: 'backgroundPhotoIds',
      };

    const label = imagesConfig.label;
    const tip = imagesConfig.tip;
    const key = imagesConfig.key;
    const placeholder = imagesConfig.placeholder;
    const countLimit = imagesConfig.countLimit;

    const firstImageId = publicData?.backgroundPhotoIds;
    const firstImagePresents = !!images.filter(img => img?.id?.uuid === firstImageId)?.length
    const newFirstImagePresents = !!images.filter(img => typeof img.id === 'string' && img.id?.includes('backgroundPhoto-'))?.length;

    const imagesArray = firstImagePresents || newFirstImagePresents ? images?.slice(0,1) : [];
    const showAddImageField = imagesArray?.length < countLimit;
    // const showAddImageField = images?.length < countLimit;
    return (
      <>
        <p className={css.fieldLabel}>{label}</p>
        <p className={css.fieldLabelTip}>{tip}</p>
        <AddImages
          key={key}
          className={css.imagesField}
          images={imagesArray}
          thumbnailClassName={css.thumbnail}
          savedImageAltText={intl.formatMessage({
            id: 'EditListingPhotosForm.savedImageAltText',
          })}
          onRemoveImage={onRemoveImage}
          imageKey={key}
          isOffer={isOffer}
        >
          {showAddImageField && (
            <Field
              id={key}
              name={key}
              accept={ACCEPT_IMAGES}
              form={null}
              label={placeholder}
              type="file"
              disabled={imageUploadRequested}
            >
              {fieldprops => {
                const { accept, input, label, disabled: fieldDisabled } = fieldprops;
                const { name, type, index } = input;
                const onChange = e => {
                  const file = e.target.files[0];
                  const newFile = replaceFileName(file, key);

                  form.change(key, newFile);
                  form.blur(key);

                  onImageUploadHandler(newFile);
                };
                // const inputProps = { accept, id: name, name, onChange, type };

                const inputProps = {
                  id: name,
                  name,
                  type,
                  accept,
                  ...(isMobSaf ? {
                    onChange: e => {
                      // const file = e.target.files[0];
                      // form.change(`addImage`, file);
                      // form.blur(`addImage`);
                      // onImageUploadHandler(file);
                      const file = e.target.files[0];
                      const newFile = replaceFileName(file, key);

                      form.change(key, newFile);
                      form.blur(key);

                      onImageUploadHandler(newFile);
                    }
                  } : {
                    onClick: e => this.handleShowCrop(e, key)
                  })
                };

                return (
                  <div className={css.addImageWrapper}>
                    <div className={css.aspectRatioWrapper}>
                      {fieldDisabled ? null : (
                        <input {...inputProps} className={css.addImageInput} />
                      )}
                      <label
                        htmlFor={name}
                        className={css.addImage}
                      >
                        {label}
                      </label>
                    </div>
                  </div>
                );
              }}
            </Field>
          )}

          <Field
            component={props => {
              const { input, meta } = props;
              return (
                <div className={css.imageRequiredWrapper}>
                  <input {...input} />
                </div>
              );
            }}
            name="images"
            type="hidden"
          />
        </AddImages>

        <ImageCrop
          key="ImageCrop.backgroundPhoto"
          isOpen={showCrop}
          submitFile={file => handleSubmitFile(file, "backgroundPhoto")}
          onClose={handleCloseCropPopup}
          namePrefix="backgroundPhoto"
          aspect={1/1}
          minWidth={100}
          minHeight={100}
        />
      </>
    );
  }
}

BackgroundPhoto.defaultProps = { fetchErrors: null, images: [] };

BackgroundPhoto.propTypes = {
  fetchErrors: shape({
    publishListingError: propTypes.error,
    showListingsError: propTypes.error,
    uploadImageError: propTypes.error,
    updateListingError: propTypes.error,
  }),
  images: array,
  intl: intlShape,
  onImageUpload: func,
  onUpdateImageOrder: func,
  onSubmit: func,
  saveActionMsg: string,
  disabled: bool,
  ready: bool,
  updated: bool,
  updateInProgress: bool,
  onRemoveImage: func,
};

export default compose(injectIntl)(BackgroundPhoto);
